import Constants from '../definitions/constants';
import { intl } from '../locales/localesConfig';
import JavascriptUtilsTooling from './javascriptUtilsTooling';

const EtlToooling = {
  getEtlTransformationsColumnOptions: (metricsList, formData, metricsPath, etlDefinitionPath = null) => {
    // Returns a processed array with the options for the ETL transformations columns (by default all of them, considering the metric selected).
    // If etlDefinitionPath is provided, the function will also return a processed array with the options for the ETL transformations columns that are not selected yet.
    var etlTransformationsOptions = [{value: "", label:""}];
    var etlFullTransformationsOptions = [];
    if(metricsList && JavascriptUtilsTooling.getObjectStringPathKeyValue(formData, metricsPath)) {
      let groupMetricsList = JavascriptUtilsTooling.getObjectStringPathKeyValue(formData, metricsPath);
      let dimensionsAdded = false;
      groupMetricsList.forEach(item => {
        let foundedMetric = metricsList.find(itemTested => itemTested.id==item.id);
        if(foundedMetric) {
          if(!dimensionsAdded) {
            etlTransformationsOptions = etlTransformationsOptions.concat(foundedMetric.dimension_hash.map(dimension => {
              return {value: "id" + dimension.id, label: dimension.name};
            }));
            dimensionsAdded = true;
          }
          if(foundedMetric.object_definition) {
            etlTransformationsOptions = etlTransformationsOptions.concat(foundedMetric.object_definition.map(objectDef => {
              return {value: "m" + foundedMetric.id + "." + objectDef.id, label: foundedMetric.name + " -> " + objectDef.name};
            }));
          } else {
            etlTransformationsOptions.push({value: "m" + foundedMetric.id, label: foundedMetric.name});
          }
        }
      });
      let etlTransformationsValues = !etlDefinitionPath ? null : JavascriptUtilsTooling.getObjectStringPathKeyValue(formData, etlDefinitionPath);
      etlTransformationsValues = etlTransformationsValues ? etlTransformationsValues.map(etlTransValue => etlTransValue.column_id): [];
      etlFullTransformationsOptions = etlTransformationsOptions;
      etlTransformationsOptions = etlTransformationsOptions.filter(item => !etlTransformationsValues.includes(item.value));

      if(etlDefinitionPath) {
        return [etlFullTransformationsOptions, etlTransformationsOptions];
      }
      else{
        return [etlFullTransformationsOptions]
      }
    }
    else{
      return [[], []];
    }
  },

};

export default EtlToooling;


// WEBPACK FOOTER //
// ./source/tooling/etlTooling.js